import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { addDays, startOfMonth, endOfMonth, isWeekend, format } from 'date-fns';
import Header from "../../../components/Header";
import { mockHorasTrabalhadas } from '../../../data/mockData';
import { useNavigate, useParams } from "react-router-dom";

const handleApprove = () => {
  // Lógica para aprovar a despesa
  console.log("Despesa aprovada!");
};

const generateMonthDays = (year, month, id) => {
  const days = [];
  const startDate = startOfMonth(new Date(year, month));
  const endDate = endOfMonth(startDate);

  // Filtrar as horas trabalhadas com base no ID da timesheet
  const horasTrabalhadasTimesheet = mockHorasTrabalhadas.find(item => item.id === parseInt(id));

  

  // Verificar se encontrou a timesheet
  if (horasTrabalhadasTimesheet) {
    for (let date = startDate; date <= endDate; date = addDays(date, 1)) {
      const horasTrabalhadas = horasTrabalhadasTimesheet.horas.find(item => format(item.date, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd'));
      days.push({
        date,
        isWeekend: isWeekend(date),
        horasTrabalhadas: horasTrabalhadas ? horasTrabalhadas.horas : 0,
      });
    }
  }

  return days;
};

const isPending = mockHorasTrabalhadas.estado = "Pendente";

const feriados = [
  '01-01', // Ano Novo
  '04-25', // Dia da Liberdade
  '05-01', // Dia do Trabalhador
  '06-10', // Dia de Portugal
  '08-15', // Assunção de Nossa Senhora
  '10-05', // Implantação da República
  '11-01', // Dia de Todos os Santos
  '12-01', // Restauração da Independência
  '12-08', // Imaculada Conceição
  '12-25'  // Natal
];

const isHoliday = (date) => {
  const formattedDate = format(date, 'MM-dd');
  return feriados.includes(formattedDate);
};

const DetalhesHoras = () => {
  const { id } = useParams(); // Obtendo o ID da URL
  const navigate = useNavigate();
  const currentDate = useMemo(() => new Date(), []);
  const [days, setDays] = useState(generateMonthDays(currentDate.getFullYear(), currentDate.getMonth(), id));

  useEffect(() => {
    const newDays = generateMonthDays(currentDate.getFullYear(), currentDate.getMonth(), id);
    setDays(newDays);
  }, [currentDate, id]);

  const initialValues = {
    days: days.reduce((acc, day) => {
      acc[format(day.date, 'yyyy-MM-dd')] = day.horasTrabalhadas.toString();
      return acc;
    }, {}),
  };

  const validationSchema = yup.object().shape({
    days: yup.object().shape(
      days.reduce((acc, day) => {
        acc[format(day.date, 'yyyy-MM-dd')] = yup.number().nullable(true).positive('Horas devem ser positivas').integer('Horas devem ser números inteiros').min(0, 'Horas não podem ser negativas').max(24, 'Não pode ser mais de 24 horas');
        return acc;
      }, {})
    ),
  });

  const calculateTotalHours = (values) => {
    let total = 0;
    for (const day in values.days) {
      total += parseFloat(values.days[day]) || 0;
    }
    return total;
  };

  return (
    <Box m="20px">
      <Header title="Folha de Horas Mensais" subtitle="Folha de horas trabalhadas" />

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        onSubmit={(values, actions) => {
          console.log(values);
          actions.resetForm();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => {

          const totalHours = calculateTotalHours(values);

          return (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="20px"
                gridTemplateColumns="repeat(7, minmax(0, 1fr))"
              >
                {days.map((day) => (
                  <TextField
                    key={day.date.toString()}
                    type="number"
                    label={format(day.date, 'dd MMM (EEE)')}
                    name={`days.${format(day.date, 'yyyy-MM-dd')}`}
                    value={values.days[format(day.date, 'yyyy-MM-dd')]}
                    onChange={(e) => {
                      handleChange(e);
                      const newTotal = calculateTotalHours({
                        ...values,
                        days: {
                          ...values.days,
                          [format(day.date, 'yyyy-MM-dd')]: e.target.value
                        }
                      });
                      setFieldValue('totalHours', newTotal);
                    }}
                    onBlur={handleBlur}
                    error={!!errors.days && !!errors.days[format(day.date, 'yyyy-MM-dd')]}
                    helperText={errors.days && errors.days[format(day.date, 'yyyy-MM-dd')] ? errors.days[format(day.date, 'yyyy-MM-dd')] : ""}
                    fullWidth
                    variant="filled"
                    sx={{ bgcolor: day.isWeekend || isHoliday(day.date) ? 'lightgray' : 'inherit' }}
                    inputProps={{ min: "0", step: "1" }}
                    disabled={true}
                  />
                ))}
              </Box>
              <Box mt="20px">
                <TextField
                  label="Total de Horas"
                  value={totalHours}
                  fullWidth
                  variant="filled"
                  disabled
                />
              </Box>
              <Box display="flex" justifyContent="space-between" sx={{ gridColumn: "span 4"}}>
  
            <Button marginTop="10px" variant="contained" color="secondary" onClick={() => navigate("/despesas")}>
                Voltar
              </Button>
            {isPending && (
                <Button type="button" onClick={handleApprove} color="success" variant="contained">
                  Aprovar Despesa
                </Button>
                )}          
            </Box>
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default DetalhesHoras;
